import React from "react";
import Form from "../components/Form";
import { ToastContainer } from "react-toastify";

const HomePage = () => {
  return (
    <div>
      <ToastContainer />
      <Form />
    </div>
  );
};

export default HomePage;
